import axios from 'axios';
import { API_URL } from './config';

class Utils
{
	getToken = () => localStorage.getItem('userAuthToken');

	setToken = (token) => localStorage.setItem('userAuthToken', token);

	deleteToken = () => localStorage.removeItem('userAuthToken');

	fetch = (endpoint) => axios.get(`${API_URL}${endpoint}`,
		{ headers : { 'Authorization': this.getToken(), 'Cache-Control': 'no-cache' }
		});

	store = (endpoint, data) => axios.post(`${API_URL}${endpoint}`, data,
		{ headers : { 'Authorization': this.getToken(), 'Cache-Control': 'no-cache' }
		});
	storeFormData = (endpoint, formData) => axios.post(`${API_URL}${endpoint}`, formData,
		{ headers : { 'Authorization': this.getToken(), 'Cache-Control': 'no-cache', 'Content-Type': 'multipart/form-data' }
		});
	update = (endpoint, data) =>
	{
		return axios.put(`${API_URL}${endpoint}`, data,
			{ headers : { 'Authorization': this.getToken(), 'Cache-Control': 'no-cache' }
			});
	}

	destroy = (endpoint) =>
	{
		return axios.delete(`${API_URL}${endpoint}`,
			{ headers : { 'Authorization': this.getToken(), 'Cache-Control': 'no-cache' }
			});
	}

}

const utils = new Utils();

export default utils;
